import { render, staticRenderFns } from "./API.vue?vue&type=template&id=49a4bdd1&scoped=true"
import script from "./API.vue?vue&type=script&lang=js"
export * from "./API.vue?vue&type=script&lang=js"
import style0 from "./API.vue?vue&type=style&index=0&id=49a4bdd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a4bdd1",
  null
  
)

export default component.exports